module.exports = __webpack_public_path__ + "static/media/Mentorship-2.1200cb6c.jpg";